// Importance icon — a small colored dot indicating an event's importance.

interface ImportanceIconProps {
  importance?: "high" | "normal" | "low" | string | null;
  size?: "sm" | "md" | "lg";
}

const SIZE_CLASSES: Record<string, string> = {
  sm: "w-2 h-2",
  md: "w-3 h-3",
  lg: "w-4 h-4",
};

const IMPORTANCE_CLASSES: Record<string, string> = {
  high: "bg-red-500",
  normal: "bg-yellow-500",
  low: "bg-green-500 opacity-40",
};

export function ImportanceIcon({ importance, size = "md" }: ImportanceIconProps) {
  const imp = (importance || "normal").toLowerCase();
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  const importanceClass =
    IMPORTANCE_CLASSES[imp] || IMPORTANCE_CLASSES.normal;
  return (
    <span
      className={`inline-block rounded-full ${sizeClass} ${importanceClass}`}
      title={`Importance: ${importance || "normal"}`}
    />
  );
}

export default ImportanceIcon;
